// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v1/langfuse.proto (package infinigence.infini.agentplatform.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb.js";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v1/langfuse.proto.
 */
export const file_agentplatform_v1_langfuse: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gnostic_openapi_v3_annotations, file_google_api_field_behavior, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message infinigence.infini.agentplatform.v1.Trace
 */
export type Trace = Message<"infinigence.infini.agentplatform.v1.Trace"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"timestamp"
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @gotags: json:"input,omitempty"
   *
   * @generated from field: google.protobuf.Value input = 4;
   */
  input?: Value | undefined;

  /**
   * @gotags: json:"output,omitempty"
   *
   * @generated from field: google.protobuf.Value output = 5;
   */
  output?: Value | undefined;

  /**
   * @gotags: json:"session_id,omitempty"
   *
   * @generated from field: string session_id = 6 [json_name = "session_id"];
   */
  sessionId: string;

  /**
   * @gotags: json:"release,omitempty"
   *
   * @generated from field: string release = 7;
   */
  release: string;

  /**
   * @gotags: json:"version,omitempty"
   *
   * @generated from field: string version = 8;
   */
  version: string;

  /**
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 9 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"metadata,omitempty"
   *
   * @generated from field: google.protobuf.Value metadata = 10;
   */
  metadata?: Value | undefined;

  /**
   * @gotags: json:"meta,omitempty"
   *
   * @generated from field: string meta = 11;
   */
  meta: string;

  /**
   * @gotags: json:"tags,omitempty"
   *
   * @generated from field: repeated string tags = 12;
   */
  tags: string[];

  /**
   * @gotags: json:"public"
   *
   * @generated from field: bool public = 13;
   */
  public: boolean;

  /**
   * @gotags: json:"environment,omitempty"
   *
   * @generated from field: string environment = 14;
   */
  environment: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Trace.
 * Use `create(TraceSchema)` to create a new message.
 */
export const TraceSchema: GenMessage<Trace> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_langfuse, 0);

/**
 * @generated from message infinigence.infini.agentplatform.v1.TraceDetails
 */
export type TraceDetails = Message<"infinigence.infini.agentplatform.v1.TraceDetails"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"timestamp"
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @gotags: json:"input,omitempty"
   *
   * @generated from field: google.protobuf.Value input = 4;
   */
  input?: Value | undefined;

  /**
   * @gotags: json:"output,omitempty"
   *
   * @generated from field: google.protobuf.Value output = 5;
   */
  output?: Value | undefined;

  /**
   * @gotags: json:"session_id,omitempty"
   *
   * @generated from field: string session_id = 6 [json_name = "session_id"];
   */
  sessionId: string;

  /**
   * @gotags: json:"release,omitempty"
   *
   * @generated from field: string release = 7;
   */
  release: string;

  /**
   * @gotags: json:"version,omitempty"
   *
   * @generated from field: string version = 8;
   */
  version: string;

  /**
   * @gotags: json:"user_id,omitempty"
   *
   * @generated from field: string user_id = 9 [json_name = "user_id"];
   */
  userId: string;

  /**
   * @gotags: json:"metadata,omitempty"
   *
   * @generated from field: google.protobuf.Value metadata = 10;
   */
  metadata?: Value | undefined;

  /**
   * @gotags: json:"meta,omitempty"
   *
   * @generated from field: string meta = 11;
   */
  meta: string;

  /**
   * @gotags: json:"tags,omitempty"
   *
   * @generated from field: repeated string tags = 12;
   */
  tags: string[];

  /**
   * @gotags: json:"public"
   *
   * @generated from field: bool public = 13;
   */
  public: boolean;

  /**
   * @gotags: json:"environment,omitempty"
   *
   * @generated from field: string environment = 14;
   */
  environment: string;

  /**
   * @gotags: json:"html_path,omitempty"
   *
   * @generated from field: string html_path = 15 [json_name = "html_path"];
   */
  htmlPath: string;

  /**
   * @gotags: json:"latency,omitempty"
   *
   * @generated from field: double latency = 16;
   */
  latency: number;

  /**
   * @gotags: json:"total_cost,omitempty"
   *
   * repeated Observation observations = 18;
   * repeated Score scores = 19;
   *
   * @generated from field: double total_cost = 17 [json_name = "total_cost"];
   */
  totalCost: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.TraceDetails.
 * Use `create(TraceDetailsSchema)` to create a new message.
 */
export const TraceDetailsSchema: GenMessage<TraceDetails> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_langfuse, 1);

/**
 * @generated from message infinigence.infini.agentplatform.v1.Observation
 */
export type Observation = Message<"infinigence.infini.agentplatform.v1.Observation"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"trace_id"
   *
   * @generated from field: string trace_id = 2 [json_name = "trace_id"];
   */
  traceId: string;

  /**
   * "span", "generation", or "event"
   * @gotags: json:"type"
   *
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @gotags: json:"start_time"
   *
   * @generated from field: google.protobuf.Timestamp start_time = 5 [json_name = "start_time"];
   */
  startTime?: Timestamp | undefined;

  /**
   * @gotags: json:"end_time"
   *
   * @generated from field: google.protobuf.Timestamp end_time = 6 [json_name = "end_time"];
   */
  endTime?: Timestamp | undefined;

  /**
   * @gotags: json:"latency,omitempty"
   *
   * @generated from field: double latency = 7;
   */
  latency: number;

  /**
   * @gotags: json:"status_code,omitempty"
   *
   * @generated from field: string status_code = 8 [json_name = "status_code"];
   */
  statusCode: string;

  /**
   * @gotags: json:"input,omitempty"
   *
   * @generated from field: google.protobuf.Value input = 9;
   */
  input?: Value | undefined;

  /**
   * @gotags: json:"output,omitempty"
   *
   * @generated from field: google.protobuf.Value output = 10;
   */
  output?: Value | undefined;

  /**
   * @gotags: json:"metadata,omitempty"
   *
   * @generated from field: google.protobuf.Value metadata = 11;
   */
  metadata?: Value | undefined;

  /**
   * "DEBUG", "DEFAULT", "WARNING", "ERROR"
   * @gotags: json:"level,omitempty"
   *
   * @generated from field: string level = 12;
   */
  level: string;

  /**
   * @gotags: json:"parent_observation_id,omitempty"
   *
   * @generated from field: string parent_observation_id = 13 [json_name = "parent_observation_id"];
   */
  parentObservationId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Observation.
 * Use `create(ObservationSchema)` to create a new message.
 */
export const ObservationSchema: GenMessage<Observation> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_langfuse, 2);

/**
 * @generated from message infinigence.infini.agentplatform.v1.Score
 */
export type Score = Message<"infinigence.infini.agentplatform.v1.Score"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"trace_id"
   *
   * @generated from field: string trace_id = 2 [json_name = "trace_id"];
   */
  traceId: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @gotags: json:"value"
   *
   * @generated from field: double value = 4;
   */
  value: number;

  /**
   * @gotags: json:"comment,omitempty"
   *
   * @generated from field: string comment = 5;
   */
  comment: string;

  /**
   * @gotags: json:"observer,omitempty"
   *
   * @generated from field: string observer = 6;
   */
  observer: string;

  /**
   * @gotags: json:"created_at"
   *
   * @generated from field: int64 created_at = 7 [json_name = "created_at"];
   */
  createdAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.Score.
 * Use `create(ScoreSchema)` to create a new message.
 */
export const ScoreSchema: GenMessage<Score> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_langfuse, 3);

/**
 * @generated from message infinigence.infini.agentplatform.v1.LangfuseQueryFilter
 */
export type LangfuseQueryFilter = Message<"infinigence.infini.agentplatform.v1.LangfuseQueryFilter"> & {
  /**
   * One of: "datetime", "string", "number", "stringOptions", "categoryOptions", "arrayOptions", "stringObject", "numberObject", "boolean", "null"
   * @gotags: json:"type,omitempty"
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @gotags: json:"column,omitempty"
   *
   * @generated from field: string column = 2;
   */
  column: string;

  /**
   * e.g. "=", ">", "<", "contains"
   * @gotags: json:"operator,omitempty"
   *
   * @generated from field: string operator = 3;
   */
  operator: string;

  /**
   * Required only when filtering on metadata
   * @gotags: json:"value,omitempty"
   *
   * @generated from field: google.protobuf.Value value = 4;
   */
  value?: Value | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.v1.LangfuseQueryFilter.
 * Use `create(LangfuseQueryFilterSchema)` to create a new message.
 */
export const LangfuseQueryFilterSchema: GenMessage<LangfuseQueryFilter> = /*@__PURE__*/
  messageDesc(file_agentplatform_v1_langfuse, 4);

